{
  "es": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Cambiar fase",
        "reset_columns": "Restablecer columnas"
      },
      "labels": {
        "columns": "Columnas",
        "milestone": "Selecciona una nueva fase",
        "no_results": "No se han encontrado unidades"
      }
    }
  }
}
